export default __webpack_public_path__ + "staticlp3/media/epoca.130cab0f.jpg";